import React from 'react';

export type ProgressIndicatorProps = {
  color: string;
  total: number;
  current: number;
  width?: number | string;
};

const WIDTH = 180;
const HEIGHT = 8;

export const ProgressIndicator = ({
  total,
  current,
  color,
  width = WIDTH,
}: ProgressIndicatorProps) => {
  const progress = React.useMemo(() => {
    if (total <= 0) {
      // total value should be greater than 0
      return 0;
    }

    if (current > total) {
      // progress should not be greater than 1
      return 1;
    }

    return current / total;
  }, [total, current]);

  return (
    <svg
      width={width}
      height={HEIGHT}
      style={{
        borderRadius: `${HEIGHT / 2}px`,
        // overflow: 'hidden'
      }}
    >
      <rect
        x='0'
        y='0'
        width='100%'
        height='100%'
        rx={HEIGHT / 2}
        fill='#EEEEEE'
        stroke={color}
        strokeWidth='2'
      />

      <defs>
        <pattern id='backgroundPattern' patternUnits='userSpaceOnUse' width={70} height='100%'>
          <image
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAADhCAYAAAByfIirAAAQUElEQVR4Ae3cYZLjuBGEUYXD9z+CfS9fxo4CjR4su9iEBK0aJB7/zCwnuBITX2YVKAKPx+Px38fj8Z/H4/HPx/nxj8fj8e//XxPXufZYM1rh6ogObLzOxlNh9a+BsHJtf1GgFa2ysIugW52N7s5qL1R0Wr1dmWtp1WtAXGVKPR5ZWK2oVa5OczYTKgIozp8drt0qIq2+k4INbHynYjvzMhsvX/j/QNt3VoIuHyI6M29ORt5Z8VGiFhMxUYJFOYUNbEzFBiABORWQOvbyi7zOKqFSWAmrBItyChvYmIoNQAJyKiB1VjorQG4KCGfhzAsX9QLzMi/zXtS8q3WhwkpYCSthVZfazf5g/9vawNm/sICdP2BjBcR+zSmu8rKA536ey8qamqzxJ6hAFQqMmCigisX0uMpZas+O6LzatZWrL7CiIoYIZ8dqQrnf/kJWoWrDCle5o3D1GlclsJ7ZXia6sBZIXRkgQ4Ew4H4aiCtsVDZGcqPlamh7GWEFyCMghRU2jtgYyY2Xt4gZ+VDX3hvmqIjlAWl+m19nTYv6p0W02jr4L3iO/kIoUGFjU4AXJveCAZp8gAZ/0TO+xvc2xQjMYL4NzIK9/FB220cxwkpYCSvTwPo2wNRBJ6yElbASVsLqyAXa9Xu368bX+P4d3tdZ6ayOuMIGNqZiA5CAnApIXZmuDJCbAsJZOPPCdb3wbf3X1L8IqLyXqLzxlnu7/ise4OIqj0kFtJ+Nsnqi/hoAqhyoOAuq56CyvYydTzI3jfio7gRSKnaEVVTE+B+eHSMf6tp+419RqwpVWwRxlTvqiuP7W9+55aoElpX1oAoFRoHcTwNxhat3c2V7mZypYfPGM5u201jtGY6wysEaLQqrc2UbkIQrUI1NXaPTKg9IE23bU3Qe03m1IhhcnR6gAtURJNjAxlRsABKQUwH5hudsq0+pbtuVCSthJaw2BXhhci8YoMkHSKdxiRdo+egDPiLyB0QWOALnqH3FRj8bwkpYHfkIG9iYig1AAnIqIHUa/Z3GaloJK2ElrDYFeGFyLxigyQdoterpfnVWR9Uzzu/Xf932PQ1G+JgR4i13XNlMIMudkQaprJ5Yeb2bcM6QGlsE3a6sr2zR+f06jxj/itdWrkrVDbCiIsaNnB1XvFnf+TPT3gpVDSpcHbsJk/1MtlyVwLKyPgcLVP1QhVb7aSCucBUKjPqo5cr2MjlTwyLHNKjtNFabFgmrHKxR867OlW1AEq5A9VxntTdRVMRo488OOo/pvFoRDK5OD1CB6ggSbGBjKjYACcipgHzD85B9N7hal3Lb+xVWwkpYbQrwwuReMECTD5BO42MvwfLC5F4wQJMPkLASVket72psCCthdeQFbGBjKjYACcipgFytW3C//Z2zsBJWwmpTgBcm94IBmnyAVN7+ykur22v1bf3Xbd/TAPPHYI633Nv1X7FECVd5D6th6GejrJ5Yeb0bE73fRO3K+soWnd+v82pBV7kqVTfAiooYIpwdqwnlfp+rgLHouQYVro7dhKvXuCpwWVmfgwWqfqhCq/00EFe4CgVGfdRyZXuZnKlhkWMa1HYaq02LhFUO1qh5V+fKNiAJV6B6rrPamygqYnlAmmjbnqLzmM6rFcHg6vQAFaiOIMEGNqZiA5CAnArINzwP2XeDq3Upt71fYSWshNWmAC9M7gUDNPkA6TTKDxq37RaMb//4CithpbPSWdVfuKcuCsJKWAkrYSWsjlyg9e1vfWlFKz5STS5RTYSVsBJWwkpY/eACISkkf8Djtx4ffVv/NfVDNia6hIniLfd2/VcUBlzl7v8t41/xc8vqidplgCoHKs5ecXB/6zvXbUBwdcxT/ZffGqMrfm7lqlTsgCsqYtzI2XHFm/WdP9PhVKjasMJV7ihM9jP5xdX/AHatvZvwOxt/AAAAAElFTkSuQmCC'
            width={70}
            height='100%'
            preserveAspectRatio='xMidYMid slice'
            opacity='0.15'
          />
        </pattern>
      </defs>

      <rect x='0' y='0' width='100%' height='100%' rx={HEIGHT / 2} fill='url(#backgroundPattern)' />
      <rect x='0' y='0' width={`${progress * 100}%`} height='100%' rx={HEIGHT / 2} fill={color} />
    </svg>
  );
};
